import EvBookingEditor from '../EvBookingEditor/EvBookingEditor';
import ProjectWizard from '../ProjectWizard/ProjectWizard';
import FilesEditor from '../EvBookingEditor/FilesEditor/FilesEditor';
import EvCastEditor from '../EvBookingEditor/EvCastEditor/EvCastEditor';
import ServiceEditor from '../EvBookingEditor/ServiceEditor/ServiceEditor';
import EvCategoriesEditor from '../EvBookingEditor/EvCategoriesEditor/EvCategoriesEditor';
import EvTaskEditor from '../EvBookingEditor/EvTaskEditor/EvTaskEditor';
import EvBookingAgenda from '../EventFinder/EvBookingAgenda';
import EvBookingCopyForm from '../EvBookingEditor/CopyForm/CopyForm';
import EvBookingView from '../EvBookingEditor/EvBookingView';
import RoomBlockingForm from '../EvBookingEditor/RoomBlockingForm/RoomBlockingForm';
import OverlappingBookingsView from '../EvBookingEditor/OverlappingBookingsView/OverlappingBookingsView';

import { MainCatalogTypes } from "./MainCatalogTypes";

enum VAMclassNames {
    "ev_booking" = "ev_booking",
    "ev_task_descript" = "ev_task_descript",
    "ev_task_single" = "ev_task_single",
    "ev_cast" = "ev_cast",
    "performers" = "performers",
    "ev_program" = "ev_program",
    "opus" = "opus",
    "ev_catagories_1" = "ev_catagories_1",
    "ht_evbooking_evcategorie1" = "ht_evbooking_evcategorie1",
    "file_ev_project" = "file_ev_project",
    "service_ev_serv" = "service_ev_serv",
    "pos_ev_serv" = "pos_ev_serv",
    "ev_task_type_A0" = "ev_task_type_A0",
    "ev_projects" = "ev_projects",
    "performer_contract" = "performer_contract",
}


export {
    EvBookingEditor,
    EvBookingAgenda,
    ProjectWizard,
    FilesEditor,
    EvCastEditor,
    ServiceEditor,
    EvCategoriesEditor,
    EvTaskEditor,
    VAMclassNames,
    EvBookingCopyForm,
    EvBookingView,
    RoomBlockingForm,
    OverlappingBookingsView,
    type VAMtypes
}

/* diverse wiederkehrende Typisierungen */
namespace VAMtypes {

    
    export interface EvRoomEntity extends MainCatalogTypes.EvRoomEntity_Short {
        /* im Prinzip sollte es das gleiche sein wie bei MainCatalogs, aber ich kann es hier nicht unter Alias rausgeben */
    }

    export interface EvService {
        ID: string;
        Classname: string; // VAMclassNames.service_ev_serv, // geht das?
        order: number;
        service_type: number;
        description: string;
        description_D?: string;
        description_E?: string;
        quantity: number;
        unitCode: string;
        ref_ev_task_descript?: EvTaskDescript;
    }
    export interface EvServiceBooking {
        ID: string;
        Classname: string; //VAMclassNames.pos_ev_serv, // geht das?
        order: number;
        serviceID: string;
        service_txt: string;
        ev_service_text_internal?: string;
        description: string;
        service_original_description?: string;
        service_type: number;
        service_type_text: number;
        quantity: number;
        quantity_text: string;
        unitCode: string;
        is_oversteered_price: boolean;
        is_price_total_pricelist: boolean;
        price_unit_pricelist: number;
        price_total_pricelist: number;
        value_agiodisagio_unit: number;
        value_agiodisagio_total: number;
        discount: number;
        value_discount_unit: number;
        value_discount_total: number;
        price_unit_change: number;
        price_total_after_disc: number;
        price_unit_after_disc: number;
        VAT_value: number;
        price_total_incl_VAT: number;
        ref_pricelist: {
            ID: string;
            price_net: number;
        }
        evTasks: Array<{ ID: string }>;
        is_cancelled: boolean;
    }

    export interface EvTaskDescript {
        ID: string;
        is_active: string;
        description: string;
        description_D: string;
        description_E: string;
        code: string;
        order: number;
        qty_needed: number;
    }

    export interface EvTaskSingle {
        ID: string;
        ref_associate: Object;
    }

    export interface EvRoom {
        gDisp_1: string;
        is_with_public: boolean;
        ID: string;
        venueID: string;
        venueCode: string;
        venueDescription: string;
        is_vacant_on_date: boolean;
    }

    export interface EvBookingEditorEntity extends EvBookingEntity_Short{
        orchestraEmployments: Array<any>;
        evCategories: Array<any>;
        existingFiles: Array<any>;
        cast: Array<any>;
        program: Array<any>;
        service: Array<any>;
        evTasks: Array<any>;
        ref_audience_seating_layouts: AudienceSeatingLayout;

    }


    export interface EvBookingEntity_Short extends more.EntityAPIResult {
        date_end: string; //TODO: das war mal Date
        date_start: string; //TODO: das war mal Date
        ref_ev_project: EvProjectEntity_Short;
        is_full_time: boolean;
        gDisp_1: string;
        ev_booking_name: string;
        ref_ev_activity_status: EvActivityStatusEntity;
        ref_ev_room: EvRoomEntity;
        ref_ev_booking_status: EvBookingStatusEntity;
    }

    export interface EvActivityStatusEntity  {
        ID: string;
        description: string;
        coloration: more.EntityAPIColor;
    }
    export interface EvBookingStatusEntity {
        ID: string;
        description: string;
        coloration: more.EntityAPIColor;
    }

    export interface EvProjectEntity_Short extends more.EntityAPIResult {
        ev_project_name: string;
        gDisp_1: string;
        ref_artistic_period: {
            ID: string,
            description: string
        }
        ref_financial_period: {
            ID: string,
            description: string
        }
        note: string
        ref_ev_project_type_2: {
            ID: string,
            description: string
        }
        ref_projectleader: {
            ID: string,
            gDisp_1: string
        }
        ref_promoter_1: {
            ID: string,
            ref_address: {
                ID: string,
                gDisp_1: string
            }
        }
        ref_promoter_2: {
            ID: string,
            ref_address: {
                ID: string,
                gDisp_1: string
            }
        }
    }

    export interface AudienceSeatingLayout extends ApiEntity {
        code: string;
        description: string;
        gDisp_1: string;
        note: string;
        seating_capacity: number;
        is_default: boolean;
    }

    export interface DateSet {
        dateStart: Date,
        dateEnd: Date,
        isFulltime: boolean
    }

    export interface CopyFormData_EvBooking {
        evProjectID: string,
        sourceBookingID: string,
        targetDates: Array<DateSet> | any,
        copyEvProgram: boolean,
        copyEvCast: boolean,
        copyEvServiceBookings: boolean,
        activityStatusID: string,
        bookingStatusID: string,
        evRoomID: string,
        overlappingCheckOnly?: boolean,
        ignoreOverlappings?: boolean
    }

    export interface CopyFormData_EvProject {
        evProjectID: string,
        evProjectName: string,
        targetBookings: Array<string>,
        copyEvProgram: boolean,
        copyEvCast: boolean,
        copyEvTask: boolean,
        copyEvServiceBookings: boolean,
        dateShift: number
    }

    export interface CopyFormResponse<T> {
        result: "success" | string,
        message?: string,
        data: T
    }

    export interface EvBookingViewResponse {
        isHTMLdetailtext: boolean,
        content: string,
        entity: EvBookingEntity_Short
    }

    export interface RoomBlockingFormData {
        datesToBlock: Array<DateSet> | any,
        evRoomID: string,
        listEvRoomID?: string[],
        evProjectID?: string
    }

    export interface RoomBlockingFormResponse {
        result: "success" | string,
        message?: string,
        data: any
    }
}
/**
 * Verwenden dies, um Probleme mit zirkulärer Abhängigkeit zu vermeiden 
 */